import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "react-i18next";

import { Select } from "components";
import { BankCreditRequestForm, SwissCanton } from "types";

interface CantonSelectProps {
  fieldName: "canton" | "previousCanton" | "mortgageCanton";
  form: UseFormReturnType<BankCreditRequestForm>;
  list: SwissCanton[];
  disabled?: boolean;
  required?: boolean;
}

export const CantonSelect = ({
  fieldName,
  form,
  list,
  disabled = false,
  required = false,
}: CantonSelectProps) => {
  const { t } = useTranslation();

  return (
    <Select
      label={t("user.address.canton.label")}
      data={list}
      key={form.key(fieldName)}
      value={form.getValues()?.[fieldName]?.value}
      onChange={(_value, option) => {
        form.setFieldValue(fieldName, {
          value: option.value,
          label: option.label,
        });
      }}
      error={form.errors[fieldName]}
      clearable={true}
      required={required}
      disabled={disabled}
    />
  );
};
